// A deadline is a calendar date ("2026-12-01"), not an instant: format it in
// UTC so it doesn't read as the day before west of Greenwich.
const FORMAT = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' })

export function formatDeadline(iso) {
    return FORMAT.format(new Date(`${iso}T00:00:00Z`))
}
